/* Speed Junkies - $5 VIP Membership landing page. Scoped to .sj-v sections. */
(function () {
  'use strict';

  if (window.__sjVipLoaded) return;
  window.__sjVipLoaded = true;

  var ENTRIES_API = '/apps/api/product-entries';

  function fmtInt(n) {
    try { return Number(n).toLocaleString(document.documentElement.lang || 'en-US'); }
    catch (e) { return String(n); }
  }

  /* ---------------------------------------------------------------- purchase */
  function initPurchase(root) {
    if (root.dataset.sjReady === '1') return;
    root.dataset.sjReady = '1';

    var form = root.querySelector('[data-sj-vip-form]');
    var errEl = root.querySelector('[data-sj-vip-error]');
    var revealBtn = root.querySelector('[data-sj-vip-reveal]');
    var hiddenBox = root.querySelector('[data-sj-vip-hidden-form]');
    var consentFallback = root.querySelector('[data-sj-vip-consent-fallback]');
    var busy = false;

    if (revealBtn && hiddenBox) {
      revealBtn.addEventListener('click', function () {
        hiddenBox.hidden = false;
        revealBtn.hidden = true;
        var b = hiddenBox.querySelector('[data-sj-vip-submit]');
        if (b) b.focus();
      });
    }

    /* Shopify injects #shopify-buyer-consent with the accelerated checkout button.
       Only show our own copy of the disclosure if that never appears. */
    if (consentFallback) {
      var syncConsent = function () {
        var native = root.querySelector('#shopify-buyer-consent');
        consentFallback.hidden = !!native;
        return !!native;
      };
      syncConsent();
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (syncConsent()) mo.disconnect(); });
        mo.observe(root, { childList: true, subtree: true });
        window.setTimeout(function () { mo.disconnect(); syncConsent(); }, 12000);
      } else {
        var tries = 0;
        var iv = window.setInterval(function () {
          tries++;
          if (syncConsent() || tries > 20) window.clearInterval(iv);
        }, 500);
      }
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function clearError() {
      if (!errEl) return;
      errEl.hidden = true;
      errEl.textContent = '';
    }

    function setBusy(on) {
      busy = on;
      var btns = root.querySelectorAll('[data-sj-vip-submit]');
      Array.prototype.forEach.call(btns, function (b) {
        b.disabled = on;
        b.setAttribute('aria-busy', on ? 'true' : 'false');
        var spin = b.querySelector('[data-sj-spin]');
        if (spin) spin.hidden = !on;
        var lbl = b.querySelector('[data-sj-label]');
        if (lbl && on && b.getAttribute('data-busy-label')) lbl.textContent = b.getAttribute('data-busy-label');
        if (lbl && !on && b.getAttribute('data-idle-label')) lbl.textContent = b.getAttribute('data-idle-label');
      });
      document.querySelectorAll('[data-sj-vip-sticky] [data-sj-vip-submit]').forEach(function (b) {
        b.disabled = on;
      });
    }

    if (!form) return;

    form.addEventListener('submit', function (ev) {
      if (busy) { ev.preventDefault(); return; }
      var variantInput = form.querySelector('[name="id"]');
      var planInput = form.querySelector('[name="selling_plan"]');
      if (!variantInput || !variantInput.value) return; /* let Shopify handle / fail loudly */
      if (form.getAttribute('data-sj-ajax') !== 'true') return; /* classic POST fallback */

      ev.preventDefault();
      clearError();
      setBusy(true);

      var item = { id: variantInput.value, quantity: 1 };
      if (planInput && planInput.value) item.selling_plan = planInput.value;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) {
          return r.json().then(function (body) { return { ok: r.ok, status: r.status, body: body }; });
        })
        .then(function (res) {
          if (!res.ok) {
            var m = (res.body && (res.body.description || res.body.message)) || form.getAttribute('data-error-generic');
            throw new Error(m);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'sj-vip' } }));
          if (form.getAttribute('data-sj-checkout') === 'true') {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          setBusy(false);
          if (window.console && console.warn) console.warn('[Speed Junkies] VIP add to cart failed.', err);
          showError(err && err.message ? err.message : (form.getAttribute('data-error-generic') || 'Something went wrong. Please try again.'));
        });
    });

    /* Sticky bar and any secondary CTA submit the one real product form. */
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-sj-vip-proxy]');
      if (!t) return;
      ev.preventDefault();
      if (busy) return;
      var box = root.querySelector('[data-sj-vip-hidden-form]');
      if (box && box.hidden) {
        box.hidden = false;
        if (revealBtn) revealBtn.hidden = true;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* -------------------------------------------------- fixed entry confirmation */
  function confirmEntries(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sj-vip-entries][data-product-id]');
    if (!nodes.length) return;
    var ids = [];
    Array.prototype.forEach.call(nodes, function (n) {
      var id = n.getAttribute('data-product-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    fetch(ENTRIES_API + '?products=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('entries endpoint responded ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data || data.success !== true || !data.products) return;
        Array.prototype.forEach.call(nodes, function (n) {
          var rec = data.products[n.getAttribute('data-product-id')];
          if (!rec || typeof rec.entries !== 'number') return;
          n.setAttribute('data-has-override', rec.hasOverride ? 'true' : 'false');
          var rendered = parseInt(n.getAttribute('data-entries') || '0', 10);
          if (rendered === rec.entries) return; /* already correct, leave the server markup alone */
          /* The entry service value is authoritative; the theme only mirrors it. */
          var prefix = n.getAttribute('data-prefix') || '+';
          var suffix = n.getAttribute('data-suffix') || '';
          n.textContent = prefix + fmtInt(rec.entries) + (suffix ? ' ' + suffix : '');
          n.setAttribute('data-entries', String(rec.entries));
          if (window.console && console.warn) {
            console.warn('[Speed Junkies] VIP entry total in the theme (' + rendered + ') did not match the entry service (' + rec.entries + '). The service value is shown.');
          }
        });
      })
      .catch(function (err) {
        /* Keep the server rendered fixed value on screen. */
        if (window.console && console.warn) console.warn('[Speed Junkies] Could not confirm the VIP entry total; showing the published value.', err && err.message ? err.message : err);
      });
  }

  /* ------------------------------------------------------------- sticky bar */
  function initSticky(bar) {
    if (bar.dataset.sjReady === '1') return;
    bar.dataset.sjReady = '1';

    var target = document.querySelector('[data-sj-vip-purchase]');
    var trigger = document.querySelector('[data-sj-vip-sticky-after]') || document.querySelector('[data-sj-vip-hero]');

    function setVisible(on) { bar.setAttribute('data-visible', on ? 'true' : 'false'); }
    setVisible(false);

    if (!('IntersectionObserver' in window)) { setVisible(true); return; }

    var pastHero = false, cardVisible = false;
    function sync() { setVisible(pastHero && !cardVisible); }

    if (trigger) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; });
        sync();
      }, { threshold: 0 }).observe(trigger);
    } else {
      pastHero = true;
    }

    if (target) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { cardVisible = e.isIntersecting; });
        sync();
      }, { threshold: 0.25 }).observe(target);
    }

    /* Never sit on top of another fixed bar the theme or an app already shows. */
    var offset = parseInt(bar.getAttribute('data-bottom-offset') || '0', 10);
    if (offset > 0) bar.style.bottom = offset + 'px';
    sync();
  }

  function boot(scope) {
    var r = scope || document;
    Array.prototype.forEach.call(r.querySelectorAll('[data-sj-vip-purchase]'), initPurchase);
    Array.prototype.forEach.call(r.querySelectorAll('[data-sj-vip-sticky]'), initSticky);
    confirmEntries(r);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });

  window.SJVip = { boot: boot };
})();